<div id="wrapped_home" class="body">
  <div class="container">
    <div class="RegistrarUsuarioIF">
      <div class="row justify-content-md-center pt-5">
        <div class="col-12 col-sm-12">
          <h1 class="txtbienvenida">Crear usuario <span class="txtbienvenida-2">Aliado Financiero</span></h1>
        </div>
      </div>

      <form class="custom-form" [formGroup]="crearUsuarioIFForm">
        <div class="row justify-content-md-center">
          <div class="col-12 col-sm-12 mt-4">
            <h5>DATOS GENERALES</h5>
          </div>
        </div>

        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-3">
            <div class="form-label" [ngClass]="{err: isValidForm('primerNombre')}">
              <label for="primerNombre" class="form-label">Primer Nombre*</label>
              <input type="text" class="form-control" (keypress)="validateLetters($event)" maxlength="20" formControlName="primerNombre" [ngClass]="{'is-invalid':isValidForm('primerNombre')}" required />
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>

          </div>
          <div class="col-12 col-sm-3">
            <div class="form-label">
              <label for="segundoNombre" class="form-label">Segundo Nombre</label>
              <input type="text" (keypress)="validateLetters($event)" class="form-control" maxlength="20" formControlName="segundoNombre" />
            </div>
          </div>
          <div class="col-12 col-sm-3">
            <div class="required form-label" [ngClass]="{err: isValidForm('primerApellido')}">
              <label for="primerApellido" class="form-label">Primer Apellido*</label>
              <input type="text" class="form-control" (keypress)="validateLetters($event)" maxlength="20" formControlName="primerApellido" [ngClass]="{'is-invalid':isValidForm('primerApellido')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3">
            <div class="form-label">
              <label for="segundoApellido" class="form-label">Segundo Apellido</label>
              <input type="text" class="form-control" (keypress)="validateLetters($event)" maxlength="20" formControlName="segundoApellido" />

            </div>
          </div>
        </div>

        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-3">
            <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('idTipoDocIdentidad_NeoTipoDocIdentidad')}">
              <label for="tipoDoc" class="form-label">Tipo de identificación</label>
              <select name="miselectTI" class="form-control" formControlName="idTipoDocIdentidad_NeoTipoDocIdentidad" [ngClass]="{'is-invalid':isValidForm('idTipoDocIdentidad_NeoTipoDocIdentidad')}" (change)="validarSelect()" required>
                <option [value]="''">Seleccione una opción</option>
                @for (item of listaDocumentos; track item) {
                  <option [value]="item.idTipoDocIdentidad">{{item.nombre}}</option>
                }
              </select>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3">
            <div class="required form-label" [ngClass]="{err: isValidForm('numeroDocumento')}">
              <label for="numDoc" class="form-label">Número de identificación*</label>
              <input type="text" class="form-control" (keypress)="validateDocument($event)" #input (input)="input.value=$event.target.value.toUpperCase()" minlength="5" maxlength="10" formControlName="numeroDocumento" [ngClass]="{'is-invalid':isValidForm('numeroDocumento')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="required form-label" [ngClass]="{err: isValidForm('cargo')}">
              <label for="cargo" class="form-label">Cargo*</label>
              <input type="text" class="form-control" (keypress)="validateLetters($event)" maxlength="50" formControlName="cargo" [ngClass]="{'is-invalid':isValidForm('cargo')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-6">
            <div class="required form-label" [ngClass]="{err: isValidForm('correoElectronico')}">
              <label for="email" class="form-label">Correo electrónico*</label>
              <input type="email" class="form-control" maxlength="50" formControlName="correoElectronico" [ngClass]="{'is-invalid':isValidForm('correoElectronico')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3">
            <div class="required form-label" [ngClass]="{err: isValidForm('celular')}">
              <label for="celular" class="form-label">Celular*</label>
              <input type="text" class="form-control" maxlength="10" (keypress)="validateNumber($event)" formControlName="celular" [ngClass]="{'is-invalid':isValidForm('celular')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3">
            <div class="required form-label" [ngClass]="{err: isValidForm('sucursalOficina')}">
              <label for="sucursal" class="form-label">Sucursal y/o oficina*</label>
              <input type="text" class="form-control" maxlength="50" formControlName="sucursalOficina" [ngClass]="{'is-invalid':isValidForm('sucursalOficina')}" required/>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-6">
            <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('idDepartamento')}">
              <label for="departamento" class="form-label">Departamento oficina</label>
              <select name="miselectDep" class="form-control" formControlName="idDepartamento" (change)="getCiudades($event.target.value)" [ngClass]="{'is-invalid':isValidForm('idDepartamento')}" required>
                <option [value]="''">Seleccione una opción</option>
                @for (item of departamentos; track item) {
                  <option value="{{item.idDepartamento}}">{{item.nombreDepartamento}}</option>
                }
              </select>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('idCiudad')}">
              <label for="ciudadOficina" class="form-label">Ciudad oficina</label>
              <select name="miselectCiu" class="form-control" formControlName="idCiudad" [ngClass]="{'is-invalid':isValidForm('idCiudad')}" required>
                <option [value]="''">Seleccione una opción</option>
                @for (item of ciudades; track item) {
                  <option value="{{item.idCiudad}}">{{item.nombreCiudad}}</option>
                }
              </select>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="col-12">
            <div class="row align-items-center">
              <div class="col-12 col-sm-5 col-sm-offset-1">
                <div class="mb-3 form-label">
                  <label for="roles" class="form-label">Roles disponibles*</label>
                  <select class="form-control selectpicker" id="addRoles" #addRoles multiple [formControl]="rolesDisponibles" title="Seleccione rol disponible"
                    data-size="5" data-live-search="true" multiple data-width="100%">
                    @for (rol of listaRoles; track rol) {
                      <option [value]="rol.idRol">
                        {{ rol.nombre }}
                      </option>
                    }
                  </select>
                </div>
                <button type="button" class="btn btn-primary w-100 mb-2 mt-5" (click)="addRolAll()">
                  <div class="d-flex flex-row align-items-center justify-content-center">
                    <img src="./assets/img/icos/add_circle_outline_white_24dp.svg" alt="" class="me-3">
                    Añadir todos
                  </div>
                </button>
              </div>
              <div class="col-12 col-sm-2 text-center">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-primary me-1 mb-2" (click)="removeRol()">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <img src="./assets/img/icos/keyboard_double_arrow_left_white_24dp.svg" alt="">
                    </div>
                  </button>
                  <button type="button" class="btn btn-primary ms-1 mb-2" (click)="addRol()">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <img src="./assets/img/icos/keyboard_double_arrow_right_white_24dp.svg" alt="">
                    </div>
                  </button>
                </div>
              </div>
              <div class="col-12 col-sm-5 col-sm-offset-1">
                <div class="mb-3 form-label">
                  <label for="rolesAsignados" class="form-label">Roles asignados*</label>
                  <select class="form-control selectpicker" id="deleteRoles" #deleteRoles multiple [formControl]="rolesSeleccionados" title="Seleccione rol asignado"
                    data-size="5" data-live-search="true" multiple data-width="100%">
                    @for (rol of listaRolesSeleccionados; track rol) {
                      <option [value]="rol.idRol">
                        {{ rol.nombre }}
                      </option>
                    }
                  </select>
                  @if (isValidForm('listaRolesSeleccionados')) {
                    <div class="invalid-feedback">
                      Campo obligatorio
                    </div>
                  }
                </div>
                <button type="button" class="btn btn-primary w-100 mb-2 mt-5" (click)="removeRolAll()">
                  <div class="d-flex flex-row align-items-center justify-content-center">
                    <img src="./assets/img/icos/remove_circle_outline_white_24dp.svg" alt="" class="me-3">
                    Eliminar todos
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-6">
            <div class="form-label">
              <label for="montoVentas" class="form-label">Monto de ventas inicial atendido</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-dollar-sign"></i></span>
                  <input type="text" class="form-control" maxlength="11" formControlName="ventaIncialAtendido"/>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-label">
                <label for="montoVentasFinal" class="form-label">Monto de ventas final atendido</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fas fa-dollar-sign"></i></span>
                    <input type="text" class="form-control" maxlength="11" formControlName="ventaFinalAtendido"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-md-center mt-4">
              <div class="col-12 col-md-6 mt-3 text-center">
                <div class="form-check form-switch d-inline-flex align-items-center gap-2">
                  <input class="form-check-input" type="checkbox" role="switch"
                    formControlName="aplicaTodosDepartamentos"
                    id="customSwitch1" checked (change)="actualizarDepartamentos()" aria-checked="false" />
                    <label class="form-check-label" for="customSwitch1">
                      Aplica para atender todos los departamentos
                    </label>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                  <div class="mb-3  form-label">
                    <label for="departamento" class="form-label">Departamento</label>
                    <select #departamentosSeleccionados id="departamentosSeleccionados" class="form-control selectpicker" multiple data-size="5" data-live-search="true"
                      formControlName="departamentosSeleccionados" title="Seleccione una opción">
                      @for (dp of listDepartamentos; track dp) {
                        <option [value]="dp.idDepartamento">
                          {{ dp.nombreDepartamento | uppercase }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mt-5 justify-content-md-center g-3">
                <div class="col-12 col-md-2 container-btn">
                  <button [disabled]="!crearUsuarioIFForm.valid" style="width: 180px;" (click)="crearUsuario()" class="btn btn-primary hvr-shrink" type="submit">Crear Usuario</button><br>
                </div>
                <div class="col-12 col-md-2 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="cancelar()">Volver</button><br>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="footer-body"></div>
      </div>

      <!-- Modal -->
      <div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body-monto justify-content-md-center">
              <div class="row">
                <div class="col-12 col-sm-12 me-2 ms-3">
                  <h2>El usuario ha sido creado exitosamente</h2>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-md-center">
              <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
            </div>
          </div>
        </div>
      </div>
      <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
